export default __webpack_public_path__ + "assets/favicon-192x192.png";